/*
 * @Author: randy
 * @Date: 2020-07-31 13:24:58
 * @LastEditTime: 2020-09-14 16:55:31
 * @Description: 用户相关接口
 */
import request from "@/utils/request";

const userApi = {
  Login: "/user/admin/password/login",
  loginAddSmsCode: "/user/sms/login",
  Logout: "/user/logout"
};

/**
 * @Author: randy
 * @description: 登录接口 获取token
 * @param {object}
 * @return: {object}
 */
export function login(data) {
  // 不需要版本号 单独处理
  return request({
    url: userApi.Login,
    method: "post",
    data
  });
}

export function loginAddSmsCode(params) {
  return request({
    url: userApi.loginAddSmsCode,
    method: "post",
    data: params
  });
}

export function sendCode(params) {
  return request({
    url: "/user/sendCode",
    method: "get",
    params: params
  });
}

// 获取token
export function loginByWechat(data) {
  return request({
    url: "/user/wechat/login",
    method: "post",
    data
  });
}

// 发送验证码
export function sendCodeByWechat(params) {
  return request({
    url: "/user/wechat/bind/sendCode",
    method: "get",
    params: params
  });
}
// 绑定手机
export function bindPhoneByWechat(data) {
  return request({
    url: "/user/sms/wechat/bind/login",
    method: "post",
    data
  });
}
/**
 * @Author: randy
 * @description: 退出接口
 * @param {type}
 * @return:
 */
export function logout(params) {
  return request({
    url: userApi.Logout,
    method: "get",
    params
  });
}
/**
 * @Author: randy
 * @description: 获取用户菜单 权限
 * @param
 * @return: Array
 */
export function getPermissions() {
  return request({
    url: `/menus/menuList`,
    method: "get"
  });
}

// 修改密码
export function updatePwd(data) {
  return request({
    url: "/user/updatePwd",
    method: "post",
    data
  });
}
// 添加用户
export function add(params) {
  return request({
    url: "user/add",
    method: "post",
    data: params
  });
}

// 查询用户列表
export function userList(params) {
  return request({
    url: "user/list",
    method: "get",
    params
  });
}
// 删除用户
export const deleteUser = id => {
  return request({
    url: `/user/delete/${id}`,
    method: "get"
  });
};
// 用户类型
export function getUserType(params) {
  return request({
    url: "role/list",
    method: "get",
    params
  });
}
// 用户辅导员
export function getCounselor(params) {
  return request({
    url: "user/counselor/list",
    method: "get",
    params
  });
}
// 查询用户信息
export const userInfo = id => {
  return request({
    url: `/user/query/${id}`,
    method: "get"
  });
};
// 编辑用户
export function updateUser(params) {
  return request({
    url: "user/update",
    method: "post",
    data: params
  });
}
// 获取验证码
export function getCodeByNewPhone(params) {
  return request({
    url: "user/getCodeByNewPhone",
    method: "get",
    params
  });
}
// 获取用户个人信息
export function getUserPersonalInfo(params) {
  return request({
    url: "user/getUserPersonalInfo",
    method: "get",
    params
  });
}
// 更新用户基本信息
export function updateUserBaseInfo(data) {
  return request({
    url: "user/updateUserBaseInfo",
    method: "post",
    data
  });
}
// 修改手机号
export function updateUserPhone(data) {
  return request({
    url: "user/updateUserPhone",
    method: "post",
    data
  });
}
// 个人中心更新用户密码
export function updatePassWord(params) {
  return request({
    url: "user/updatePassWord",
    method: "post",
    data: params
  });
}
// 修改头像
export function updateHeadImage(data) {
  return request({
    url: "user/updateHeadImage",
    method: "post",
    data
  });
}
// 修改单位信息
export function updateUserWorkInfo(params) {
  return request({
    url: "user/updateUserWorkInfo",
    method: "post",
    data: params
  });
}
// 更新证书
export function updateUserCertificate(params) {
  return request({
    url: "user/updateUserCertificate",
    method: "post",
    data: params
  });
}
// 修改工作经历
export function updateStudentWorkExtend(params) {
  return request({
    url: "user/updateStudentWorkExtend",
    method: "post",
    data: params
  });
}
// 修改获奖经历
export function updateStudentAwardExtend(params) {
  return request({
    url: "user/updateStudentAwardExtend",
    method: "post",
    data: params
  });
}
// 获取当前用户的待办
export function queryExaminationPaperList(params) {
  return request({
    url: "task/user/queryExaminationPaperList",
    method: "get",
    params
  });
}
// 获取学习情况
export function getClinicalPracticeByUser(params) {
  return request({
    url: "ClinicalPractice/getClinicalPracticeByUser",
    method: "get",
    params
  });
}
// 获取学员分布
export function getUserMap(params) {
  return request({
    url: "statistics/stu/map/count",
    method: "get",
    params
  });
}

// 用户必填信息校验
export function useInfoCheck(params) {
  return request({
    url: "user/useInfoCheck",
    method: "get",
    params
  });
}

// 用户必填信息保存
export function saveUserRegisterInfo(params) {
  return request({
    url: "user/saveUserRegisterInfo",
    method: "post",
    data: params
  });
}
// 获取职称列表
export const titleList = (params = {}) => {
  return request({
    url: "title/list",
    method: "get",
    params
  });
};

//获取科室列表
export const departmentList = (params = {}) => {
  return request({
    url: "department/list",
    method: "get",
    params
  });
};

//查看学员信息
// user/student/detail
// weChat/student/detail
export const studentDetail = params => {
  return request({
    url: "user/student/detail",
    method: "get",
    params
  });
};
// 完善学员信息
export function studentInfo(params) {
  return request({
    url: "user/student/update",
    method: "post",
    data: params
  });
}
// 获取状态
export function studentStatus() {
  return request({
    url: "user/student/getStatus",
    method: "get"
  });
}
// 用户注册
export function register(data) {
  return request({
    url: "user/register",
    method: "post",
    data
  });
}
//找回密码
export function getPassword(data) {
  return request({
    url: "user/forget/password",
    method: "post",
    data
  });
}
//密码登录
export function pswLogin(data) {
  return request({
    url: "user/student/password/login",
    method: "post",
    data
  });
}
